module.exports = __webpack_public_path__ + "static/media/speachInactive.c83a77d0.svg";